<template>
    <div class="list-caption">

        <button class="btn-toggle" type="button" @click="openCaptionEditor()" v-if="ownsList">

            <span class="save">
                <svg><use xlink:href="#pen"></use></svg>
            </span>

        </button>

        <div class="content">

            <div v-if="!hasCaption && ownsList" class="caption-text">
                <p class="full-caption">
                    Add a note...
                </p>
            </div>

            <!-- If has a long caption -->
            <div v-else-if="hasLongCaption" class="caption-text">
                <p class="full-caption" v-if="showingFullCaption">
                    <span v-text="currentCaption"></span>
                    <button type="button" @click="toggleShowCaption()">Less -</button>
                </p>
                <p class="short-caption" v-else>
                    <span v-text="strLimit(currentCaption, 60)"></span>
                    <button type="button" @click="toggleShowCaption()">More +</button>
                </p>
            </div>

            <!-- If has a short caption -->
            <div v-else class="caption-text">
                <p class="full-caption" v-text="currentCaption"></p>
            </div>

        </div>
    </div>
</template>
<script>
export default {

    props:['list', 'spot'],

    data(){
        return {
            currentSpot: this.spot,
            currentCaption: null,
            showingFullCaption: false,
        }
    },

    created() {
        eventBus.$on('spot-' + this.currentSpot.id + '-caption-updated', caption => {
            this.currentSpot.pivot.caption = caption;
            this.currentCaption = caption
        })

        if(this.currentSpot.hasOwnProperty('note')) {
            this.currentCaption = this.currentSpot.note
        }
        if(this.currentSpot.hasOwnProperty('pivot') && this.currentSpot.pivot.hasOwnProperty('caption')) {
            this.currentCaption = this.currentSpot.pivot.caption
        }
    },

    methods:{



        openCaptionEditor(){
            eventBus.$emit('open-edit-caption-dialog', this.currentSpot)
        },

        toggleShowCaption(){
            this.showingFullCaption = !this.showingFullCaption;
        },

        strLimit(str) {
            return str.substring(0, 100);
        },
    },

    computed: {

        hasCaption() {
            return this.currentCaption
        },

        hasLongCaption(){
            if(!this.hasCaption){
                return false
            }
            return this.currentCaption.length > 100;
        },

        ownsList() {
            return window.config.isLoggedIn && window.config.user.id == this.list.user_id;
        },
    },

    beforeDestroy() {
        eventBus.$off('spot-' + this.currentSpot.id + '-caption-updated')
    }

}
</script>
